interface DelayFunction {
    (ms: number): Promise<void>;
}

const delay: DelayFunction = (ms: number): Promise<void> => new Promise<void>(res => setTimeout(res, ms));

export {delay};


